import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Menu, Text } from '@fragments';
import { IconAspectRatio, IconTypography } from '@tabler/icons-react';
import ColorField from '../../ColorPicker';
import { Divider } from '../controls';
import { formatRatios } from '../../../../model/schema';
import { applyBrandFonts } from '../../../../model/operations';

// Nothing selected: the page itself (background, aspect ratio) and the brand faces.
export default function PageSection({ editor, colors, brandKit }) {
  const { t } = useTranslation('artEditor');
  const doc = editor.document;
  const ratios = formatRatios(doc.format);
  return <>
    <Text.caption contrast={6} className="art-inspector__label">{t('page')}</Text.caption>
    <ColorField label={t('background')} value={editor.page.background} modes={['solid', 'gradient']} brand={colors.brand} used={colors.used} onChange={fill => fill && editor.background(fill)} />
    {ratios.length > 1 && <Menu placement="top-start" items={ratios.map(ratio => ({ label: `${t(`ratio_${ratio.replace(':', 'x')}`)} · ${ratio}`, active: ratio === doc.aspect_ratio, onClick: () => editor.aspectRatio(ratio) }))}>
      <Button size="small" variant="text" color="overlay" dropdown preventLoading startIcon={<IconAspectRatio />} aria-label={`${t('aspectRatio')}: ${doc.aspect_ratio}`}>{doc.aspect_ratio}</Button>
    </Menu>}
    {brandKit?.fonts && <>
      <Divider />
      <Button size="small" variant="text" color="overlay" preventLoading startIcon={<IconTypography />} onClick={() => editor.apply(current => applyBrandFonts(current, brandKit.fonts), { label: 'brandFonts' })}>
        {t('applyBrandFonts')}
      </Button>
    </>}
    <Divider className="art-inspector__hint-divider" />
    <Text.caption contrast={5} className="art-inspector__label art-inspector__hint">{t('selectHint')}</Text.caption>
  </>;
}
